import React, { useCallback, useEffect, useState  } from 'react';
import { Column }      from 'primereact/column';
import { DataTable }   from 'primereact/datatable';
import { InputText }   from 'primereact/inputtext';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import ProjectService from '../../services/ProjectService';
/* import ProductService from '../../services/ProductService'; */

import './reviewerProjects.css';

const toDate = iso => new Date(`${iso}T00:00:00`);

// This is the feedback return date
const queueLink = (row) => {
    const {feedbackDate, number, name, type} = row;
    if(feedbackDate == null) {
      return <a href={`https://forms.zohopublic.com/phius/form/SubmittoProjectReviewQueue/formperma/YTSDhsbXUZkyP6UdElySMwSW7EzPvnTDKODAoPsXVJM?ID=${number}&PN=${name}&TYP=${type}`} style={{color:'#00AAAF'}}>Submit to Review Queue</a>
    } else {
      return toDate(feedbackDate).toLocaleDateString();
    }
  }

export default function ReviewerProjects() {
  const [projects, setProjects] = useState([]);

  const [filterProjects, setFilterProjects] = useState('');

  const [loadingProjects, setLoadingProjects] = useState(true);


  const normalizeProjects = useCallback(e => ({
    id: e.id,
    name: e.project_name,
    number: e.project_number,
    category: e.category,
    type: e.queue_type,
    certifier: e.queue_owner_name,
    email: e.queue_owner_email,
    stage: e.queue_stage,
    jobName: e.queue_name,
    requiredDate: e.upload_required_date,
    submissionDate: e.queue_submit_date,
    dropboxFolder: e.dropbox_folder,
    feedbackDate: e.queue_due_date,
    link: `/details/project/${e.id}`,
    status: e.status
  }),[]);
  
  /* const normalizeProducts = useCallback(e => ({
    id: e.id,
    name: e.certification_job_name,
    number: e.certification_job_number,
    submitter: e.crm_contact_name,
    category: e.window_product_category.join(', '),
    manufacturer: e.crm_account_name,
    jobFolder: e.job_folder,
    certificationDate: e.certification_job_date,
    expirationDate: e.certification_job_expiration_date,
    jobStatus: e.job_status,
  }),[]); */

  const dateBody = field => row => {
    return (
        <span className='date-body'>
{row[field] ? toDate(row[field]).toLocaleDateString() : '--'}
        </span>)}
    ;

  const editBody = row => (
      <Link
          to={row.link}
          className='event-name-cell'
        >
            <button className='button-cta-v2' type='button'>
                Edit
            </button>
        </Link>
  );

  const standardEventNameBody = row => (
    <span>
      {row?.name}
    </span>
  );

  const projectNameLink = (event) => {
      return (
        <a
          href={event.dropboxFolder}
          className='event-name-cell'
        >
          {event?.dropboxFolder ? event.name : ''}
        </a>
      );
  };

  useEffect(() => {
    let isCancelled = false;
    setLoadingProjects(true)
    ProjectService.getMyProjects()
    .then((projects) => {
      if (!isCancelled) {
        const filteredProjects =
          projects?.projects?.length > 0
            ? projects.projects.filter(
                (proj) =>
                  proj?.queue_type === 'Project Review' ||
                  proj?.queue_type === 'Expedited Project Review'
              )
            : [];
        setProjects(filteredProjects.map(normalizeProjects));
      }
    })
    .catch(err => {
      console.error('Failed to fetch all projects:', err);
    }).finally(() =>
        setLoadingProjects(false)
    );

    // PH-49 removing Products for the foreseeable future
    /* setLoadingProducts(true)
    ProductService.getMyProducts()
    .then((products) => {
      if (!isCancelled) {
        setProducts(products?.products?.length > 0 ? products.map(normalizeProducts) : []);
      }
    })
    .catch(err => {
      console.error('Failed to fetch my products:', err);
    }).finally(() => setLoadingProducts(false)); */

  return () => {
    isCancelled = true;
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="reviewer-container">
        <div className='reviewer-header'>
            <h1>MANAGE YOUR PROJECTS</h1>
            <div style={{marginTop:'0.25em'}}>
                <a className="button-cta-v2 remove-text-decoration" style={{ "marginRight": "1em" }} target="_blank" rel="noopener noreferrer" href="https://forms.zohopublic.com/phius/form/SubmitaProject/formperma/9OwDJRYIStRrYRRRW7tMOKjPxpLc1w3C1njoj1HsUrU">SUBMIT A PROJECT</a>
                {/* <a className="button-cta-v2 remove-text-decoration" style={{ "marginRight": "0.5em" }} target="_blank" rel="noopener noreferrer" href="https://forms.zohopublic.com/phius/form/SubmitaWindow1/formperma/BAVojH4UN8cz-ZeerzQz0Wqxi882i0_lMhHkZG9XxhQ">SUBMIT A PRODUCT</a> */}
            </div>
        </div>

        <>
          <div className="table-header">
            <h2>My Projects</h2>
            <div style={{ display: 'flex', flexDirection: 'column'}}>
                <label htmlFor="search-my-projects">Search</label>
                <InputText
                id="search-my-projects"
                variant="filled"
                placeholder="Search…" 
                value={filterProjects}
                onChange={e => setFilterProjects(e.target.value)}
                className="search-input-field"
                />
            </div>
          </div>
          <DataTable
            value={projects}
            paginator
            rows={5}
            globalFilter={filterProjects}
            globalFilterFields={['number', 'name', 'stage', 'certifier', 'type']}
            loading={loadingProjects}
            emptyMessage="No projects"
            responsiveLayout="scroll"
            className="p-datatable-sm custom-datatable"
            tableStyle={{ backgroundColor: '#FEFEFE', color: '#2A2E33', fontSize: '14px', lineHeight: '20px'}}
          >
            <Column field="number"     header="Project No." sortable/>
            <Column field="name"     header="Project Name" body={projectNameLink} sortable/>
            <Column field="stage" header="Stage"  sortable/>
            <Column field="type" header="Type"  sortable/>
            <Column field="jobName" header="Queue Name"  sortable/>
            <Column field="submissionDate"    header="Submission Date" align={'center'} alignHeader={'left'} body={dateBody('submissionDate')} sortable/>
            <Column field="requiredDate"      header="Upload Required Date"   align={'center'} alignHeader={'left'} body={dateBody('requiredDate')} sortable/>
            <Column field="feedbackDate"     header="Feedback Return Date"    align={'left'} alignHeader={'left'} body={queueLink}   sortable/>
            <Column field="certifier"   header="Project Certifier" sortable/>
            <Column field="edit" header={<FontAwesomeIcon icon={faEdit} />}  alignFrozen='left' align={'center'} body={editBody}/>
          </DataTable>

          {/* PH-49: Hide Product table*/}
          {/* <div className="table-header">
            <h2>My Products</h2>
            <div style={{ display: 'flex', flexDirection: 'column'}}>
            <label htmlFor="search-my-products">Search</label>
            <InputText
              id='search-my-products'
              variant="filled"
              placeholder="Search…" 
              value={filterProducts}
              onChange={e => setFilterProducts(e.target.value)}
              className="search-input-field"
              showClear
            />
            </div>
          </div>
          <DataTable
            value={products}
            paginator
            rows={5}
            globalFilter={filterProducts}
            globalFilterFields={['name', 'number', 'submitter', 'category', 'manufacturer']}
            loading={loadingProducts}
            emptyMessage="No products"
            responsiveLayout="scroll"
            className="p-datatable-sm custom-datatable"
            tableStyle={{ backgroundColor: '#FEFEFE', color: '#2A2E33', fontSize: '14px', lineHeight: '20px'}}
          >
            <Column field="name" header="Certified Job Name" body={standardEventNameBody} sortable/>
            <Column field="number"     header="Certification Job Number" sortable/>
            <Column field="submitter"  header="Submitter" sortable/>
            <Column field="category" header="Product Category" sortable/>
            <Column field="manufacturer" header="Manufacturer" />
            <Column field="jobFolder" header="Job Folder"/>
            <Column field="certificationDate"    header="Certification Job Date" align={'right'} alignHeader={'left'} body={dateBody('certificationDate')} sortable/>
            <Column field="expirationDate"      header="Certification Job Expiration Date"   align={'right'} alignHeader={'left'} body={dateBody('expirationDate')} sortable/>
            <Column field="jobStatus"   header="Job Status"/>
          </DataTable> */}
        </>
    </div>
  );
}
